import React__default from "react";
import { P as PropTypes, t as tagPropType, m as mapToCssModules } from "./utils-f8d1c624.js";
import { c as classNames } from "./index-e71f83b5.js";
var _excluded = ["className", "cssModule", "color", "body", "inverse", "outline", "tag", "innerRef"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source)
        Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
    return target;
  }, _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded), key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++)
      key = sourceSymbolKeys[i], !(excluded.indexOf(key) >= 0) && Object.prototype.propertyIsEnumerable.call(source, key) && (target[key] = source[key]);
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {}, sourceKeys = Object.keys(source), key, i;
  for (i = 0; i < sourceKeys.length; i++)
    key = sourceKeys[i], !(excluded.indexOf(key) >= 0) && (target[key] = source[key]);
  return target;
}
var propTypes = {
  /** Toggles card padding using `.card-body` */
  body: PropTypes.bool,
  /** Add custom class */
  className: PropTypes.string,
  /** Change background color of component */
  color: PropTypes.string,
  /** Change underlying component's CSS base class name */
  cssModule: PropTypes.object,
  innerRef: PropTypes.oneOfType([PropTypes.object, PropTypes.string, PropTypes.func]),
  /** Inverts the color */
  inverse: PropTypes.bool,
  /** Changes the card to have only outline */
  outline: PropTypes.bool,
  /** Set a custom element for this component */
  tag: tagPropType
};
function Card(props) {
  var className = props.className, cssModule = props.cssModule, color = props.color, body = props.body, inverse = props.inverse, outline = props.outline, _props$tag = props.tag, Tag = _props$tag === void 0 ? "div" : _props$tag, innerRef = props.innerRef, attributes = _objectWithoutProperties(props, _excluded), classes = mapToCssModules(classNames(className, "card", inverse ? "text-white" : !1, body ? "card-body" : !1, color ? "".concat(outline ? "border" : "bg", "-").concat(color) : !1), cssModule);
  return /* @__PURE__ */ React__default.createElement(Tag, _extends({}, attributes, {
    className: classes,
    ref: innerRef
  }));
}
Card.propTypes = propTypes;
export {
  Card as C
};
//# sourceMappingURL=Card-7c71d309.js.map
